import React from 'react';
import Events from '../../../Components/event';

import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';

import { ArrowLong } from '../../../../assets/img/svg/icons';
import { DetailSlider } from '../../../../assets/img/svg/details';
import { EventInterface } from '../../../Services/types';
interface EventSectionInterface {
    events: EventInterface[]
}
const EventsSection: React.FC<EventSectionInterface> = ({events}: EventSectionInterface) => {
    if(events.length == 0)
        return ;
    return (
        <section>
            <div className="bg-main-pink pt-6 pb-40 Z-0">
                <div className="max-w-screen-xl mx-auto px-4">
                    <h2 className="font-semibold text-2xl md:mb-4 text-center text-white">Próximos Eventos</h2>

                    <div className="text-white max-w-screen-lg mx-auto min-h-[570px]">
                        <Swiper
                            loop
                            className='relative'
                            modules={[Navigation]}
                            navigation={{
                                prevEl: '.swiper-prev',
                                nextEl: '.swiper-next',
                            }}
                            breakpoints={{
                                767: { slidesPerView: 2 },
                                991: { slidesPerView: 3 },
                            }}
                        >

                            {events.map((event) => (
                                <SwiperSlide key={event.id} className='flex justify-center'>
                                    <div className="py-8 px-12 relative max-w-[340px]">
                                        <Events slug={event.slug} local={event.local} title={event.titulo} type={event.tipo} date={event.data} thumbnail={event.thumbnail} />

                                        <DetailSlider className='detail-icon opacity-0 absolute -bottom-44 left-0 w-full h-80 pointer-events-none transition-all duration-300' />
                                    </div>
                                </SwiperSlide>
                            ))}

                            <div className="swiper-prev z-40 absolute top-44 left-0 cursor-pointer group">
                                <ArrowLong className='-scale-x-100 transition-all duration-200 group-hover:fill-main-blue' />
                            </div>

                            <div className="swiper-next z-40 absolute top-44 right-0 cursor-pointer group">
                                <ArrowLong className='transition-all duration-200 group-hover:fill-main-blue' />
                            </div>
                        </Swiper>
                    </div>

                    <div className="flex justify-center items-center mt-12">
                        <a href="/eventos-realizados" className="inline-block border-2 text-center border-white rounded-lg font-semibold text-white py-2 px-4 transition-all duration-200 hover:bg-white hover:text-main-pink">
                            Confira os eventos realizados nos anos anteriores
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default EventsSection;